<template>
  <div
    v-if="['paragraph', 'heading', 'subheading'].includes(localValue.type)"
    :id="'localValue' + index"
  >
    <div :id="localValue.id">
      <quill-editor
        v-model="localValue.placeholder"
        :options="editorOptions"
        @ready="onEditorReady"
        class="swipesEditor w-full"
      >
      </quill-editor>
    </div>
  </div>
</template>
<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill';
import { quillToolbar, vueQuillInit, theBlockBlot } from './custom-editor.js';
export default {
  name: 'FormParagraph',
  data() {
    return {
      //
    }
  },
  props: {
    editable: {
      required: true,
    },
    value: {
      required: true,
    },
    index: {
      required: true,
    },
    styles: {
      required: true,
    },
  },
  computed: {
    editorOptions() {
      return {
        bounds: '#groovemail-form-fields-area',
        modules: {
          toolbar: quillToolbar,
        },
        theme: 'bubble',
        scrollingContainer: '#scrolling-container',
        placeholder: this.$t('frontend_groovevideo_video_create_enter_description'),
      }
    },
    localValue: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  updated() {
      this.$nextTick(() => {
        this.setStyles();
      });
  },
  methods: {
    hide() {
      this.localValue = '';
      this.localShown = false;
    },
    onTextChange(e) {
      this.localValue.placeholder = e.target.innerText;
    },
    onEditorReady(quill) {
      this.$nextTick(() => {
        this.setStyles();
        vueQuillInit(quill);
      });
    },
    setStyles() {
      if(!['paragraph', 'heading', 'subheading'].includes(this.localValue.type)) return;
      if(!document.getElementById(this.localValue.id)) return;

      const el = document.getElementById(this.localValue.id).children[0].children[0].children[0];
      if(el.attributes.style){
        el.attributes.style.value = "";
      }
      el.style.fontFamily = (this.styles.text.fontFamily || '');
      el.style.padding = 0;
      el.style.textShadow = (this.styles.text.textShadow || '');
      el.style.fontSize = (this.styles.text.fontSize + 'px' || '');
      el.style.textAlign = (this.styles.text.textAlign || '');
      el.style.fontStyle = (this.styles.text.fontStyle || '');
      el.style.fontWeight = (this.styles.text.fontWeight || '');
      el.style.letterSpacing = (this.styles.text.letterSpacing || '');
      el.style.lineHeight = (this.styles.text.lineHeight || '');
      el.style.textDecorationLine = (this.styles.text.textDecorationLine || '');
      el.style.color = (this.styles.text.color || '');
      el.style.webkitTextStrokeWidth = (this.styles.text.textStrokeWidth || '');
      el.style.webkitTextStrokeColor = (this.styles.text.textStrokeColor || '');
      el.style.padding = this.styles.padding ? this.styles.padding.join('px ') + 'px' : '';
      el.style.margin = this.styles.margin ? this.styles.margin.join('px ') + 'px' : '';
      el.attributes.style.value += this.styles.customStyles;
    },
  },
  components: {
    quillEditor,
  },
  watch: {
    styles: {
      deep: true,
      handler(newVal, oldVal) {
        this.setStyles();
      },
    },
  }
}
</script>
